import HttpService from "../services/Http.Service";

async function getFeedbackLog(data) {
    return await HttpService.controlServerWithToken("GET", "feedback", "get_feedback_log", data);
}

async function getAvgFeedback(data) {
    return await HttpService.controlServerWithToken("GET", "feedback", "get_avg_feedback", data);
}

async function getComplaint(data) {
    return await HttpService.controlServerWithToken("GET", "feedback", "get_complaint", data);
}

async function addFeedback(data) {
    return await HttpService.controlServerWithToken("POST", "feedback", "add_feedback", data);
}

export { getFeedbackLog, getAvgFeedback, getComplaint, addFeedback };
